export interface CategoryInfo {
  key: 'movie' | 'drama' | 'variety' | 'short';
  name: string;
  en: string;
  desc: string;
  icon: string;
  cover: string;
}

export const categories: CategoryInfo[] = [
  {
    key: 'movie',
    name: '电影',
    en: 'Movie',
    desc: '院线大片、口碑佳作与经典修复，一网打尽。',
    icon: 'ri-film-line',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20genre%20banner%2C%20vintage%20projector%20beams%20cutting%20through%20dark%20air%20with%20floating%20poster%20cards%2C%20deep%20blue%20and%20gold%20tones%2C%20elegant%20minimal%20movie%20theme&width=800&height=600&seq=cat-movie&orientation=squarish',
  },
  {
    key: 'drama',
    name: '电视剧',
    en: 'Drama',
    desc: '古装权谋、都市情感与悬疑刑侦，追剧不停。',
    icon: 'ri-tv-2-line',
    cover: 'https://readdy.ai/api/search-image?query=Television%20drama%20genre%20banner%2C%20warm%20living%20room%20glow%20with%20a%20series%20of%20episode%20cards%20arranged%20in%20a%20fan%2C%20amber%20and%20teal%20tones%2C%20cozy%20binge%20watching%20mood&width=800&height=600&seq=cat-drama&orientation=squarish',
  },
  {
    key: 'variety',
    name: '综艺',
    en: 'Variety',
    desc: '真人秀、音乐竞演与脱口秀，快乐随时开场。',
    icon: 'ri-mic-line',
    cover: 'https://readdy.ai/api/search-image?query=Variety%20show%20genre%20banner%2C%20festive%20stage%20with%20colorful%20spotlights%2C%20confetti%20and%20a%20microphone%20silhouette%2C%20vibrant%20magenta%20orange%20and%20teal%20party%20palette%2C%20fun%20energetic%20visual&width=800&height=600&seq=cat-variety&orientation=squarish',
  },
  {
    key: 'short',
    name: '短视频',
    en: 'Short',
    desc: '美食、萌宠、科普与潮流，几分钟看完好内容。',
    icon: 'ri-smartphone-line',
    cover: 'https://readdy.ai/api/search-image?query=Short%20video%20genre%20banner%2C%20smartphone%20with%20a%20vertical%20video%20playing%20surrounded%20by%20play%20icons%20and%20reaction%20bubbles%2C%20bright%20playful%20coral%20and%20cyan%20tones%2C%20modern%20social%20video%20mood&width=800&height=600&seq=cat-short&orientation=squarish',
  },
];

export const categoryMap: Record<string, CategoryInfo> = {
  movie: categories[0],
  drama: categories[1],
  variety: categories[2],
  short: categories[3],
};